import { render, staticRenderFns } from "./chart1.vue?vue&type=template&id=9c24493e&scoped=true"
import script from "./chart1.vue?vue&type=script&lang=js"
export * from "./chart1.vue?vue&type=script&lang=js"
import style0 from "./chart1.vue?vue&type=style&index=0&id=9c24493e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c24493e",
  null
  
)

export default component.exports